import type { components, paths } from '@/api/clarity'
import { authTokenFunc } from '@/lib/firebase'
import createClient, { type Middleware } from 'openapi-fetch'

const authMiddleware: Middleware = {
  async onRequest({ request, schemaPath }) {
    // no auth necessary for ping requests
    if (schemaPath === '/ping' || schemaPath === '/v1/api/signin/magic-link') return request
    const token = await authTokenFunc()
    if (token) {
      request.headers.set('Authorization', `Bearer ${token}`)
    } else {
      console.warn('No user logged in, not adding any auth token')
    }
    return request
  },
}

export function versionMiddleware(appVersion: string | undefined): Middleware {
  return {
    onRequest({ request }) {
      request.headers.set('X-Clarity-Version', appVersion ?? 'unknown')
      return request
    },
  }
}

export const clarityClient = createClient<paths>()
clarityClient.use(authMiddleware)

export function apiErrorWrapper(e: components['schemas']['ErrorModel'] | string, r: Response): Error {
  // if the error was upstream from our API, it might not be the expected JSON format
  if (typeof e === 'string') {
    return new Error(`${r.status} ${r.statusText || 'Error'}: ${e || '<unknown error>'}`)
  }
  const msg = `${e.status ?? r.status ?? 999} ${e.title || r.statusText || 'Error'}: ${e.detail || '<unknown error>'}`
  return new Error(msg, { cause: e })
}
